export const REQUEST_PROFILE_RELATED_REQUESTS_COUNT_DEFAULT = 0
